import dataSelect from '@store/dataForSelect/reducers';

import { group_code_select } from '../../configs/constants';

export default dataSelect(group_code_select);
